export enum IpfsStatesEnum {
  IPFS_READY = 'IPFS.READY',
  IPFS_INITIALISING = 'IPFS.INITIALISING',
  IPFS_FINDING = 'IPFS.FINDING_PEERS',
  IPFS_FAILED = 'IPFS.FAILED',
  IPFS_PUBLISHING = 'IPFS.PUBLISHING',
}
